var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoEditing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Line_Expand",
    viewBox: "0 0 64 64",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.02,42.75h-.01a.746.746,0,0,0-.745.75.753.753,0,1,0,.755-.75Z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,.25H1A.75.75,0,0,0,.25,1V33a.75.75,0,0,0,.75.75H21.9l5.772,10-4.019,6.96a7.631,7.631,0,0,0-1.779-1.417,7.75,7.75,0,1,0,2.836,10.586l6.35-11a7.572,7.572,0,0,0,.944-.37,7.456,7.456,0,0,0,.94.37l6.35,11A7.75,7.75,0,1,0,42.128,49.29a7.631,7.631,0,0,0-1.779,1.417l-4.019-6.96,5.772-10H63a.75.75,0,0,0,.75-.75V1A.75.75,0,0,0,63,.25ZM1.75,5.75H11A2.253,2.253,0,0,1,13.25,8V26A2.253,2.253,0,0,1,11,28.25H1.75Zm21.88,28h5.2l2.308,4-2.6,4.5Zm6.928,0h2.884L32,36.247ZM23.409,59.126a6.25,6.25,0,1,1-2.287-8.537,6.19,6.19,0,0,1,2.013,1.867.75.75,0,0,0,1.268-.051l1.466-2.539,2.165,1.25ZM39.6,52.405a.75.75,0,0,0,1.268.051,6.19,6.19,0,0,1,2.013-1.867,6.25,6.25,0,1,1-2.287,8.537l-4.625-8.01,2.165-1.25Zm-2.216-3.838-2.165,1.25-1.125-1.949a.752.752,0,0,0-.456-.349l-.044-.013a7.573,7.573,0,0,0,1.763-2.069l.11-.19Zm-3.326-3.88a6.12,6.12,0,0,1-3.69,2.832.752.752,0,0,0-.456.349l-1.125,1.949-2.165-1.25,18.476-32a10.041,10.041,0,0,1-.308,9.533ZM36.617,28.25H21A2.253,2.253,0,0,1,18.75,26V8A2.253,2.253,0,0,1,21,5.75H43A2.253,2.253,0,0,1,45.25,8v6.332a.749.749,0,0,0-.8.359Zm25.633,0H53A2.253,2.253,0,0,1,50.75,26V8A2.253,2.253,0,0,1,53,5.75h9.25Zm0-24H53A3.755,3.755,0,0,0,49.25,8V26A3.755,3.755,0,0,0,53,29.75h9.25v2.5H42.968l3.118-5.4a11.533,11.533,0,0,0,.664-10.27V8A3.755,3.755,0,0,0,43,4.25H21A3.755,3.755,0,0,0,17.25,8V26A3.755,3.755,0,0,0,21,29.75H35.751l-1.443,2.5H1.75v-2.5H11A3.755,3.755,0,0,0,14.75,26V8A3.755,3.755,0,0,0,11,4.25H1.75V1.75h60.5Z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.372,51.888a4.75,4.75,0,1,0,1.738,6.488A4.755,4.755,0,0,0,20.372,51.888Zm.439,5.738a3.25,3.25,0,1,1-1.189-4.439A3.253,3.253,0,0,1,20.811,57.626Z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.378,60.115a4.75,4.75,0,1,0-6.488-1.739A4.755,4.755,0,0,0,48.378,60.115Zm-4-6.928a3.25,3.25,0,1,1-1.189,4.439A3.255,3.255,0,0,1,44.378,53.187Z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.378,16.352l-12-7A.75.75,0,0,0,26.25,10V24a.75.75,0,0,0,1.128.648l12-7A.75.75,0,0,0,39.378,16.352ZM27.75,22.694V11.306L37.512,17Z",
    fill: "#c72538",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoEditing);
export default __webpack_public_path__ + "static/media/video-editing.8a12f80538be996d6422fa52613fddaa.svg";
export { ForwardRef as ReactComponent };